module.exports = __webpack_public_path__ + "img/Fruits_et_Legumes.07e5e2ca.jpg";